import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import debounce from "lodash/debounce";

import { Input, Radio } from "antd";

import * as T from "utils/types";
import searchBlockS from "./SearchBlockSlice";
import searchPgUserInputsS from "features/content/search_page/UserInputsSlice";

const { Search } = Input;

//CreationSearchBlock
export default () => {
  const dispatch = useDispatch();
  const { searchInput_internal } = useSelector(
    (state: T.RootState) => state.searchBlock
  );
  const { keywordType } = useSelector(
    (state: T.RootState) => state.searchPgUserInputs
  );

  // const searchInputRef = useRef(null);

  const setSearchInput_debounced = useMemo(
    () =>
      debounce((value) => {
        dispatch(searchPgUserInputsS.actions.setSearchInput(value));
      }, 1000),
    [dispatch]
  );
  const setInputSearch_debounced100ms = useMemo(
    () =>
      debounce((value) => {
        dispatch(searchPgUserInputsS.actions.setSearchInput(value));
      }, 100),
    [dispatch]
  );

  return (
    <>
      <Input.Group>
        <Search
          // ref={searchInputRef}
          onChange={(event) => {
            dispatch(
              searchBlockS.actions.setSearchInput_internal(event.target.value)
            );
            setSearchInput_debounced(event.target.value);
          }}
          value={searchInput_internal}
          placeholder={
            keywordType === "search"
              ? "Search by keyword"
              : "Search by researcher name"
          }
          onSearch={(value) => {
            //dispatch(searchBlockS.actions.setSearchInput(value));
            setInputSearch_debounced100ms(value);
            // if (searchInputRef && searchInputRef.current) {
            //     // @ts-ignore
            //     searchInputRef.current.blur();
            // }
          }}
          allowClear
        />
      </Input.Group>

      <Radio.Group
        buttonStyle="solid"
        value={keywordType}
        style={{ margin: "8px 0 8px 14px" }}
        onChange={(event) => {
          dispatch(searchBlockS.actions.setSearchInput_internal(""));
          dispatch(searchPgUserInputsS.actions.setSearchInput(""));
          dispatch(
            searchPgUserInputsS.actions.setKeywordType(
              event.target.value as T.keywordType
            )
          );
        }}
      >
        <Radio value="search">Keyword</Radio>
        <Radio value="match">Researcher</Radio>
      </Radio.Group>
    </>
  );
};
